import { useMemo } from "react";
import { X } from "lucide-react";
import { ApiProvider } from "@/lib/apiClient";
import { createAgencyClient } from "@/lib/api";
import Agenda from "@/pages/salon/Agenda";

/**
 * Overlay a schermo intero che mostra la VERA agenda del salone selezionato
 * nel workspace Agenzia. Riusa la pagina Agenda del titolare rendendola
 * tenant-scoped tramite un client axios che inietta X-Act-As-Tenant.
 */
export default function AgencyAgendaModal({ tenant, onClose }) {
  const client = useMemo(() => createAgencyClient(() => tenant?.id), [tenant?.id]);
  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex flex-col" data-testid="agency-agenda-modal">
      <div className="bg-white border-b border-[color:var(--sp-border)] px-4 py-3 flex items-center gap-3 flex-shrink-0">
        <div className="min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-wider text-[color:var(--sp-brand)]">Agenda salone</div>
          <div className="font-display text-lg font-black truncate" data-testid="agency-agenda-tenant-name">{tenant?.name}</div>
        </div>
        <button onClick={onClose} data-testid="agency-agenda-close"
          className="ml-auto h-9 w-9 rounded-lg flex items-center justify-center hover:bg-[color:var(--sp-subtle)]">
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto bg-[color:var(--sp-bg)] p-4">
        <ApiProvider client={client}>
          <Agenda />
        </ApiProvider>
      </div>
    </div>
  );
}
